import React from 'react';
import { FacebookShareButton } from 'react-share';
import ZaloShareButton from '../../../../../../../common/social-share-button/ZaloShareButton';
import EmailShareButton from '../../../../../../../common/social-share-button/EmailShareButton';
import SkypeShareButton from '../../../../../../../common/social-share-button/SkypeShareButton';

class Share extends React.Component {
  render() {
    const { url } = this.props;
    const defaultURL = '';
    return (
      <div className="d-flex">
        <div style={{ marginRight: 8 }}>Share:</div>
        <div className="d-flex share-sns">
          <FacebookShareButton url={url || defaultURL}>
            <i className="icon-facebook" />
          </FacebookShareButton>
          &nbsp;
          <ZaloShareButton url={url}>
            <i className="icon-zalo" />
          </ZaloShareButton>
          &nbsp;
          <SkypeShareButton url={url}>
            <i className="icon-skype" />
          </SkypeShareButton>
          &nbsp;
          <EmailShareButton url={url}>
            <i className="icon-gmail" />
          </EmailShareButton>
        </div>
      </div>
    );
  }
}

export default Share;
